import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
// tslint:disable-next-line:no-unused-variable
import { ICrudGetAllAction, TextFormat } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './sport.reducer';
import { ISport } from 'app/shared/model/sport.model';
// tslint:disable-next-line:no-unused-variable
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface ISportProps extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export class Sport extends React.Component<ISportProps> {
  componentDidMount() {
    this.props.getEntities();
  }

  render() {
    const { sportList, match } = this.props;
    return (
      <div>
        <h2 id="sport-heading">
          Sports
          <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
            <FontAwesomeIcon icon="plus" />&nbsp; Create new Sport
          </Link>
        </h2>
        <div className="table-responsive">
          <Table responsive>
            <thead>
              <tr>
                <th>ID</th>
                <th>Name</th>
                <th>Icon Name</th>
                <th>Created Date</th>
                <th>Last Modified Date</th>
                <th>Created By</th>
                <th>Last Modified By</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {sportList.map((sport, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${sport.id}`} color="link" size="sm">
                      {sport.id}
                    </Button>
                  </td>
                  <td>{sport.name}</td>
                  <td>{sport.iconName}</td>
                  <td>
                    <TextFormat type="date" value={sport.createdDate} format={APP_DATE_FORMAT} />
                  </td>
                  <td>
                    <TextFormat type="date" value={sport.lastModifiedDate} format={APP_DATE_FORMAT} />
                  </td>
                  <td>{sport.createdBy ? sport.createdBy.login : ''}</td>
                  <td>{sport.lastModifiedBy ? sport.lastModifiedBy.login : ''}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${sport.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" /> <span className="d-none d-md-inline">View</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${sport.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" /> <span className="d-none d-md-inline">Edit</span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${sport.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" /> <span className="d-none d-md-inline">Delete</span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ sport }: IRootState) => ({
  sportList: sport.entities
});

const mapDispatchToProps = {
  getEntities
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(Sport);
